<template lang="pug">
#listBusinessServices
  .table-view-header
    .table-view-header-title
      h3 Servicios en empresa
  b-table(:items="tableItems", head-row-variant="light-primary", responsive)
    template(v-slot:cell(Acciones)="data")
      .table-actions
        b-button.tableButton(
          @click="showActivateServiceModal(data.value.service)",
          size="sm",
          variant="success",
          :disabled="data.value.service.active"
        ) Activar
        b-button.tableButton(
          @click="showDeactivateModal(data.value.service)",
          size="sm",
          variant="danger",
          :disabled="!data.value.service.active"
        ) Desactivar
        b-button.tableButton(
          @click="editDateBusinessService(data.value.service)",
          size="sm",
          variant="muted",
          :disabled="!data.value.service.active"
        ) Editar
  //- Modals
  b-modal(
    v-model="showDeactivateServiceModal",
    :hide-footer="true",
    :hide-header="true",
    no-close-on-backdrop
  )
    ModalConfirmationDeactivate(
      v-if="showDeactivateServiceModal",
      :hideModal="hideDeactivateModal",
      :selected="selected",
      :makeToast="makeToast"
    ) 
  b-modal(
    v-model="showActivateModal",
    :hide-footer="true",
    :hide-header="true",
    no-close-on-backdrop
  )
    ModalEditService(
      v-if="showActivateModal",
      title="Activar Servicio",
      btnText="Activar",
      action="activate",
      :defaultStartDate="business.startContract"
      :hideModal="hideActivateServiceModal",
      :selected="selected",
      :makeToast="makeToast"
    )
  b-modal(
    v-model="showEditModal",
    :hide-footer="true",
    :hide-header="true",
    no-close-on-backdrop
  )
    ModalEditService(
      v-if="showEditModal",
      title="Editar Servicio",
      btnText="Aceptar",
      action="edit",
      :hideModal="hideEditDateBusinessService",
      :selected="selected",
      :makeToast="makeToast"
    )
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ModalConfirmationDeactivate from "./Modals/ModalConfirmationDeactivate";
import ModalEditService from "./Modals/ModalEditService";
export default {
  components: {
    ModalConfirmationDeactivate,
    ModalEditService,
  },
  data() {
    return {
      showDeactivateServiceModal: false,
      showActivateModal: false,
      showEditModal: false,
      selected: {},
    };
  },
  computed: {
    ...mapGetters(["business"]),
    tableItems() {
      if (this.business.services) {
        return this.business.services.map((s) => {
          return {
            Nombre: s.name,
            Activo: s.active === true ? "Sí" : "No",
            "Fecha Inicio":
              s.startDate === "N/A" ? "N/A" : this.getCorrectDate(s.startDate),
            Acciones: { service: s },
          };
        });
      }
      return [];
    },
  },
  methods: {
    ...mapActions(["getBusiness", "editBusinessService"]),
    generateSelected(service) {
      return {
        serviceId: service.id,
        businessId: this.$route.params.id,
        active: service.active,
        startDate: service.startDate,
        id: service.businessServiceId,
        name: service.name,
      };
    },
    getCorrectDate(strDate) {
      let date = new Date(strDate);
      return new Date(
        date.getTime() + date.getTimezoneOffset() * 60000
      ).toLocaleDateString("es-CL");
    },
    showActivateServiceModal(service) {
      this.selected = this.generateSelected(service);
      this.showActivateModal = true;
    },
    editDateBusinessService(service) {
      this.selected = this.generateSelected(service);
      this.showEditModal = true;
    },
    showDeactivateModal(service) {
      this.selected = this.generateSelected(service);
      this.showDeactivateServiceModal = true;
    },
    async hideActivateServiceModal() {
      this.showActivateModal = false;
      await this.getBusiness(+this.$route.params.id);
    },
    async hideEditDateBusinessService() {
      this.showEditModal = false;
      await this.getBusiness(+this.$route.params.id);
    },
    async hideDeactivateModal() {
      this.showDeactivateServiceModal = false;
      await this.getBusiness(+this.$route.params.id);
    },
    makeToast(variant = null, body, title) {
      this.$bvToast.toast(body, {
        title,
        variant,
        solid: true,
        hide: true,
        autoHideDelay: 3000,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#listBusinessServices {
  margin-top: 20px;
  .container {
    .tableButton {
      margin-right: 10px;
    }
  }
}
</style>